import React from "react";
import { Route } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
// import { clearLocalStorage } from 'components/utils';
import { clearLocalStorage } from "../../components/Utils/Utils";
import { checkModuleAccess, getModule } from "../../Helpers/role";
// import appStore from 'store/App';
import appStore from "../../Store/AppStore";

const PrivateRoute = ({ name, path, basePath, action, component: Component, ...rest }) => {
  const [appState] = appStore();
  const user = JSON.parse(localStorage.getItem("user"));
  const { role } = user ? user : [];
  const { modules } = role ? role : [];
  let allowAccess = {
    name: "",
    read: false,
    create: false,
    delete: false,
    update: false,
    data: [],
  };
  if (localStorage.getItem("token") && localStorage.getItem("user")) {
    if (name === "Pengaturan") {
      if (checkModuleAccess(9)) {
        allowAccess = {
          name: name,
          read: true,
          create: false,
          delete: false,
          update: true,
          patch: true,
          data: getModule(9),
          external: {},
        };
      }
    } else {
      modules.map((value) => {
        value.features.map((row) => {
          if (basePath === row.path || path === row.path) {
            if (row.read) {
              allowAccess = {
                name: row.name,
                read: row.read,
                create: row.create,
                delete: row.delete,
                update: row.update,
                patch: row.patch,
                data: modules,
                external: row,
              };
            } else {
              if(row[action] && row[action] === true) {
                allowAccess = {
                  name: row.name,
                  read: row.read,
                  create: row.create,
                  delete: row.delete,
                  update: row.update,
                  patch: row.patch,
                  data: modules,
                  external: row,
                };
              }
            }
          }
  
          return allowAccess;
        });
        return allowAccess;
      });
    }
  } else {
    return <Redirect to="/login" />
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        (allowAccess.read || (allowAccess[action] && allowAccess[action] === true) ? (
          <Component
            {...props}
            params={allowAccess || ""}
            broadcastValue={appState.notifRuntime}
          />
        ) : (
          clearLocalStorage()
        ) /*: null*/)
      }
    />
  );
};

export default PrivateRoute;
